export default "__VITE_ASSET__CPuVsEPj__"